import type { FileRepository } from '@mote/recipes'

export class WebFileRepository implements FileRepository {
  async getFinishRecordingSound() {
    return this.#getFromBlob('/sounds/finish-recording.mp3')
  }

  async getCancelRecordingSound() {
    return this.#getFromBlob('/sounds/cancel-recording.mp3')
  }

  async #getFromBlob(url: string) {
    const response = await fetch(url)
    const blob = await response.blob()
    return URL.createObjectURL(blob)
  }
}
